<template>
  <el-form-item :label="i18nt('designer.setting.inactiveText')">
    <el-input v-model="inactiveText"></el-input>
  </el-form-item>
</template>

<script>
import { computed, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'inactiveText-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    const inactiveText = computed({
      get: function () {
        // inactiveLabel改成了inactiveText, 兼容老版本inactiveLabel
        if (props.optionModel.inactiveLabel !== undefined) {
          return props.optionModel.inactiveLabel === undefined || props.optionModel.inactiveLabel === null ? '否' : props.optionModel.inactiveLabel;
        } else {
          return props.optionModel.inactiveText === undefined || props.optionModel.inactiveText === null ? '否' : props.optionModel.inactiveText;
        }
      },
      set: function (newValue) {
        if (props.optionModel.inactiveLabel !== undefined) {
          props.optionModel.inactiveLabel = newValue;
        } else {
          props.optionModel.inactiveText = newValue;
        }
      },
    });

    return {
      i18nt,
      ...toRefs(props),

      inactiveText,
    };
  },
};
</script>

<style scoped></style>
